module.exports = __webpack_public_path__ + "img/Anhänger_MzPt.b0185f0f.svg";